export default {"src":"/_next/static/media/vue.522784e9.svg","height":221,"width":256,"blurWidth":0,"blurHeight":0};